<div class="overview-section">
  <div class="overview-heading-wrapper">
    <p class="overview-label">POS with Customer Ordering &amp; Mobile Apps</p>
    <h2 class="overview-heading">One System, Three Apps</h2>
    <p class="overview-subtitle">Everything connected — your counter, your phone, and your customers, all in sync.</p>
  </div>

  <div class="overview-shell">
    <div class="app-row" *ngFor="let app of apps; let i = index" [class.app-row--reverse]="i % 2 === 1">
      <div class="app-row-visual">
        <span class="app-row-index">{{ i + 1 }}</span>
        <img [src]="app.image" [alt]="app.name" />
      </div>
      <div class="app-row-body">
        <h3 class="app-row-title">{{ app.name }}</h3>
        <ul class="app-row-points">
          <li *ngFor="let point of app.points">{{ point }}</li>
        </ul>
      </div>
    </div>
  </div>
</div>
